import React from 'react';
import UserRow from './UserRow';

// One-time accounts, listed apart from the team rather than under a supervisor.
// They aren't team members — they're guests holding a pass to a single survey,
// and they leave on their own the moment they use it, so mixing them into the
// roster would misrepresent both. The row names the survey each one opens,
// because that is the only thing the account can do.
const OneTimeSection = ({
  accounts,
  passwords = {},
  showCompany,
  onDelete,
  canDelete,
  onResetPassword,
  canResetPassword,
  showTempPasswords,
  currentUserId,
}) => {
  if (!accounts.length) return null;

  return (
    <div className="border-b border-gray-700 last:border-b-0">
      <div className="px-6 py-3 bg-gray-900/40 flex items-baseline justify-between gap-3 flex-wrap">
        <span className="text-sm font-semibold text-white">One-time accounts</span>
        <span className="text-xs text-gray-500">
          {accounts.length} waiting · each is deleted once its survey is submitted
        </span>
      </div>
      <ul className="divide-y divide-gray-700/60">
        {accounts.map((account) => (
          <UserRow
            key={account.id}
            member={account}
            showCompany={showCompany}
            password={passwords[account.id]}
            onDelete={onDelete}
            canDelete={canDelete}
            onResetPassword={onResetPassword}
            canResetPassword={canResetPassword}
            showTempPassword={showTempPasswords}
            currentUserId={currentUserId}
            indent
          />
        ))}
      </ul>
    </div>
  );
};

export default OneTimeSection;
